// TODO: Move/merge with product util in peregrine?
export const isProductConfigurator = product => {
    try {
        if (YD_COMPONENTS.includes('YoungDogs_ConfiguratorGraphQl')) {
            // @TODO: remove parseInt() when LC-475 is fixed
            return (
                parseInt(product.yd_configurator) ||
                (product.configurator_data &&
                    JSON.parse(product.configurator_data))
            );
        }
    } catch (e) {
        return false;
    }
};

export const isProductConfiguratorLengthOnly = product => {
    try {
        return !!JSON.parse(product.configurator_data).lengthonly;
    } catch (e) {
        return false;
    }
};

export const isProductRenderable = product => {
    try {
        const { name, configurator_data } = product;

        if (!configurator_data) {
            return false;
        }

        const { lengthonly, colors } = JSON.parse(configurator_data);

        return !lengthonly && colors && colors.kast_geleiders;
    } catch (e) {
        return false;
    }
};
